const { sanitizeMultiline, sanitizeSingleLine } = require("./plainTextSanitize");

const CITIZEN_LINE_MAX = 120;
const CITIZEN_PRESENTATION_MAX = 400;
const CITIZEN_PRESENTATION_LINES = 5;

function sanitizeCitizenLine(raw) {
  return sanitizeSingleLine(raw).slice(0, CITIZEN_LINE_MAX);
}

function sanitizeCitizenPresentation(raw) {
  return sanitizeMultiline(raw)
    .split("\n")
    .slice(0, CITIZEN_PRESENTATION_LINES)
    .join("\n")
    .trim()
    .slice(0, CITIZEN_PRESENTATION_MAX);
}

function sanitizeCitizenCard(body = {}) {
  return {
    favoriteNovel: sanitizeCitizenLine(body?.favoriteNovel),
    inspiringCharacter: sanitizeCitizenLine(body?.inspiringCharacter),
    currentReading: sanitizeCitizenLine(body?.currentReading),
    presentation: sanitizeCitizenPresentation(body?.presentation),
  };
}

function emptyCitizenCard() {
  return {
    favoriteNovel: "",
    inspiringCharacter: "",
    currentReading: "",
    presentation: "",
  };
}

module.exports = {
  CITIZEN_LINE_MAX,
  CITIZEN_PRESENTATION_MAX,
  CITIZEN_PRESENTATION_LINES,
  sanitizeCitizenLine,
  sanitizeCitizenPresentation,
  sanitizeCitizenCard,
  emptyCitizenCard,
};
